<template>
  <div style="width: 100%;">
    <span>{{fileName()}}</span>
    <span v-show="!loading" class="mdl-button mdl-js-button mdl-button--icon" v-on:click="removeFile()">
      <i class="material-icons">clear</i>
    </span>
    <span v-show="loading" class="spinner">
      <!-- <img :src="'/app/static/img/loading.gif'" /> -->
      <div class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"></div>
    </span>
  </div>
</template>

<script>
module.exports = {
  ready: function () {
    this.loading = !this.file.id
  },
  props: [
    'file',
    'attachments'
  ],
  data: function () {
    return {
      loading: true
    }
  },
  methods: {
    removeFile: function () {
      var index = this.attachments.indexOf(this.file)
      this.attachments.splice(index, 1)
      this.$dispatch('remove-file', this.file)
    },
    fileName: function () {
      var name = this.file.fileName
      var delimiterIndex = name.lastIndexOf('.')
      var ext = ''
      if (delimiterIndex > -1) {
        ext = name.substring(delimiterIndex)
        name = name.substring(0, delimiterIndex)
      }
      if (name.length > 20) {
        name = name.substring(0, 17) + '...'
      }
      return name + ext
    }
  },
  events: {
    'refresh': function () {
      if (this.file && this.file.id) this.loading = false
      else this.loading = !this.file.__finished
    }
  },
  watch: {
    file: {
      handler: function (newVal) {
        this.loading = !!newVal.__finished
      },
      deep: true
    }
  }
}
</script>

<style scoped>
span img {
  height: 24px;
  margin: 5px;
}
.mdl-spinner {
  margin: 0 5px;
  height: 20px;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// Attachment.vue?1b19b68f